





























































import { Prop, Component, Vue } from "vue-property-decorator";
import formatDay from "@/helpers/formatDay";
import getDaysInEachMonth from "@/helpers/getDaysInEachMonth";

import VChartRow from "./VChartRow.vue";
import VGridRow from "../VGridRow.vue";
import VChartWeekendMask from "./VChartWeekendMask.vue";
import VGrid from "../VGrid.vue";
import VGridCell from "../VGridCell.vue";
import WeatherIcon from "../WeatherIcon.vue";
import VDaySwitch from "../VDaySwitch.vue";

@Component({
  components: {
    VChartRow,
    VGridRow,
    VGrid,
    VGridCell,
    WeatherIcon,
    VChartWeekendMask,
    VDaySwitch
  }
})
export default class VChartHeader extends Vue {
  @Prop({ default: "" }) type!: "weather" | "rokuyo" | "";
  @Prop({ default: () => [] }) days!: Date[];
  @Prop({ default: () => [] }) rokuyoDays!: string[];
  @Prop({ default: () => [] }) weatherDays!: string[];

  get cols() {
    return this.days.length;
  }

  get monthCells() {
    return getDaysInEachMonth(this.days).map(m => ({
      text: m.days > 2 ? m.key : "",
      span: m.days
    }));
  }

  get dateCells() {
    return this.days.map(d => ({
      text: d.getDate(),
      span: 1
    }));
  }

  get dayCells() {
    return this.days.map(d => ({
      text: formatDay(d),
      span: 1
    }));
  }

  get rokuyoCells() {
    return this.rokuyoDays.map(d => ({
      text: d,
      span: 1
    }));
  }

  toggle() {
    this.$emit("toggleHeaderType");
  }
}
